import useChannelListHeaderState from "Messenger/hooks/useChannelListHeaderState";
import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { getFullName } from "../../utils";
import { Dropdown } from "reactstrap";
import CreateGroupPopup from "../Modals/CreateGroupPopup";
import NewConversationPopup from "../Modals/NewConversationPopup";
import NewGroupPopup from "../Modals/NewGroupPopup";
import NewConversation from "Messenger/pages/PatientConversation/component/NewConversation";
import PerformanceReviewSearchBar from "accountOwner/pages/PerformanceReview/components/PerformanceReviewSearchBar";
import CallHistoryModal from "Messenger/pages/PatientConversation/component/CallHistoryModal";
import NotAccessibleChatCheck from "Messenger/NotAccessibleChat";

const CustomChannelListHeader = ({ t, ...props }) => {
  const {
    setChannelListQuery,
    setFilteredOffices,
    setCurrentChannel,
    filteredOffices,
    externalTabActive,
    isPatientConversation = false,
    selectedOwner,
    currentUser,
    sdk,
    updateChannelList,
    handleRequestStatusFilter,
    selectedOption,
    filteredOfficesForNew,
    setFilteredOfficesForNew,
    setSelectedOption,
    searchText,
    setSearchText,
    hasMultipleOwner,
    allChannelsOfficesForDoctor,
    setAllChannelsOfficesForDoctor,
    doctorChatCheck,
    callNextList,
    selected,
    setHasMoreOffices,
    setOfficeListLoading,
    setFilteredRoleIds,
    roleSelected,
  } = props;
  const { profilePic, isStaff, isAccountOwner } = currentUser;
  const stateData = useChannelListHeaderState({
    setChannelListQuery,
    setFilteredOffices,
    filteredOffices,
    setCurrentChannel,
    selectedOwner,
    sdk,
    currentUser,
    externalTabActive,
    t,
    updateChannelList,
    isPatient: isPatientConversation,
    filteredOfficesForNew,
    setFilteredOfficesForNew,
    hasMultipleOwner,
    doctorChatCheck,
    allChannelsOfficesForDoctor,
    setFilteredRoleIds,
  });
  const { state, updateMethods, otherMethods } = stateData;
  const {
    dropdownChatOpen,
    isNewGroupPopupOpen,
    isCreateGroupPopupOpen,
    isNewConversationPopupOpen,
    isPatientConversationPopOpen,
    isCallHistoryModalOpen,
    hasMoreOffices,
    offices,
    isNewConversationOfficePopupOpen,
    isLoadingOfficesList,
  } = state;
  useEffect(
    () => setOfficeListLoading(isLoadingOfficesList),
    [isLoadingOfficesList],
  );
  const {
    setIsNewGroupPopupOpen,
    setIsNewConversationPopupOpen,
    setIsPatientConversationPopOpen,
    setIsNewConversationOfficePopupOpen,
  } = updateMethods;
  const {
    selectedOfficesLabel,
    selectedRolesLabel,
    resetOfficePagination,
    toggleChat,
    handleFilterOffices,
    handleFilterRoles,
    loadMoreOffices,
    toggleCallHistoryPopUp,
  } = otherMethods;
  useEffect(() => {
    // Used to add values in parent state
    if (offices.length) {
      setAllChannelsOfficesForDoctor(offices);
    }
  }, [offices]);
  useEffect(() => {
    // Used this to fetch more offices if user reached at bottom of list
    if (callNextList) {
      loadMoreOffices();
    }
  }, [callNextList]);
  
  useEffect(() => {
    setHasMoreOffices(hasMoreOffices);
  }, [hasMoreOffices]);
  useEffect(() => {
    // Used this to call handleFilterOffices from the parent component and reset it once it's called.
    if (selected.applied.length) {
      selected.applied.forEach((element) => {
        handleFilterOffices(element.event, element.id, element.isChecked);
      });
    }
  }, [selected.applied]);

  useEffect(() => {
    if (roleSelected?.applied?.length) {
      roleSelected.applied.forEach((element) => {
        handleFilterRoles(element.event, element.id, element.isChecked);
      });
    }
  }, [roleSelected?.applied]);

  return (
    <>
      <div className="profile-owner-header">
        <div className="img-content-box">
          <div className="profile-image">
            <img
              className="img-cover"
              src={profilePic || require("assets/images/no-image-lg.svg")}
              alt="profile-pic"
              onError={(e) => {
                e.currentTarget.src =
                  require("assets/images/no-image-lg.svg").default;
              }}
            />
          </div>

          <div className="profile-info">
            <div className="profile-name">{getFullName(currentUser)}</div>
            {selectedOwner &&
              !externalTabActive &&
              !isAccountOwner &&
              isStaff && (
                <div className="account-ownner-desc">
                  {t("messenger.theAcountOwnerIs")} {getFullName(selectedOwner)}{" "}
                  Office
                </div>
              )}
          </div>
        </div>
        {isPatientConversation && (
          <div className="action-box" onClick={toggleCallHistoryPopUp}>
            <img
              src={require("assets/images/call_icon.svg").default}
              alt="icon"
            />
          </div>
        )}
        {!doctorChatCheck && (
          <NotAccessibleChatCheck
            patientCheck={isPatientConversation}
            dontRenderAnyChildren
          >
            <div className="action-box">
              <span
                className="plus-icon"
                onClick={() =>
                  isPatientConversation
                    ? setIsPatientConversationPopOpen(true)
                    : !externalTabActive
                      ? setIsNewGroupPopupOpen(true)
                      : setIsNewConversationPopupOpen(true)
                }
              >
                <img
                  src={require("assets/images/plus-icon-outline.svg").default}
                  alt="icon"
                />
              </span>
            </div>
          </NotAccessibleChatCheck>
        )}
      </div>
      {isPatientConversation && (
        <div className="mt-3">
          <PerformanceReviewSearchBar
            searchValue={searchText}
            handleSearchTerm={(ev) => setSearchText(ev.target.value)}
            placeholderText="Search by name"
          />
        </div>
      )}

      <div className="channel-dropdowm-wrapper mt-2 mb-3">
        <Dropdown
          isOpen={dropdownChatOpen}
          toggle={toggleChat}
          className="cursor-pointer"
        ></Dropdown>
      </div>

      {/* This show the first step of group/one-2-one creation to select the users */}
      {isNewGroupPopupOpen && (
        <NewGroupPopup
          stateData={stateData}
          selectedOfficesLabel={selectedOfficesLabel}
          selectedRolesLabel={selectedRolesLabel}
          isNewConversationOfficePopupOpen={isNewConversationOfficePopupOpen}
          setIsNewConversationOfficePopupOpen={
            setIsNewConversationOfficePopupOpen
          }
        />
      )}
      {/* This shows the 2nd Step of adding image an name to a group */}
      {isCreateGroupPopupOpen && (
        <CreateGroupPopup
          stateData={stateData}
          isPatientConversation={isPatientConversation}
        />
      )}
      {/* This is the first and only step of chat creation for external chat */}
      {isNewConversationPopupOpen && (
        <NewConversationPopup stateData={stateData} />
      )}
      {isPatientConversationPopOpen && (
        <NewConversation
          selectedOfficesLabel={selectedOfficesLabel}
          resetOfficePagination={resetOfficePagination}
          isNewConversationOfficePopupOpen={isNewConversationOfficePopupOpen}
          setIsNewConversationOfficePopupOpen={
            setIsNewConversationOfficePopupOpen
          }
          stateData={stateData}
          setSelectedOption={setSelectedOption}
          filteredOfficesForNew={filteredOfficesForNew}
          setFilteredOfficesForNew={setFilteredOfficesForNew}
          handleRequestStatusFilter={handleRequestStatusFilter}
          selectedOption={selectedOption}
        />
      )}
      {isCallHistoryModalOpen && (
        <CallHistoryModal
          t={t}
          currentUser={currentUser}
          doctorChatCheck={doctorChatCheck}
          isOpen={isCallHistoryModalOpen}
          toggleModal={toggleCallHistoryPopUp}
        />
      )}
    </>
  );
};

export default withTranslation()(CustomChannelListHeader);
